@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-1_910_620_553)
internal val Res.string.discover_groups_replying_to: StringResource by lazy {
      StringResource("string:discover_groups_replying_to", "discover_groups_replying_to", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23857, 91),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16788, 59),
      ))
    }

@delegate:ResourceContentHash(-670_978_253)
internal val Res.string.discover_groups_report: StringResource by lazy {
      StringResource("string:discover_groups_report", "discover_groups_report", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24188, 62),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16999, 38),
      ))
    }

@delegate:ResourceContentHash(1_278_616_856)
internal val Res.string.discover_groups_report_group: StringResource by lazy {
      StringResource("string:discover_groups_report_group", "discover_groups_report_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24003, 92),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16886, 60),
      ))
    }

@delegate:ResourceContentHash(-123_323_376)
internal val Res.string.discover_groups_report_post: StringResource by lazy {
      StringResource("string:discover_groups_report_post", "discover_groups_report_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24096, 91),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16947, 51),
      ))
    }

@delegate:ResourceContentHash(1_835_828_370)
internal val Res.string.discover_groups_row_banned: StringResource by lazy {
      StringResource("string:discover_groups_row_banned", "discover_groups_row_banned", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24251, 74),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17038, 54),
      ))
    }

@delegate:ResourceContentHash(-892_275_391)
internal val Res.string.discover_groups_row_chat: StringResource by lazy {
      StringResource("string:discover_groups_row_chat", "discover_groups_row_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24326, 40),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17093, 40),
      ))
    }

@delegate:ResourceContentHash(1_252_892_886)
internal val Res.string.discover_groups_row_invite_link: StringResource by lazy {
      StringResource("string:discover_groups_row_invite_link", "discover_groups_row_invite_link", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24367, 87),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17134, 55),
      ))
    }

@delegate:ResourceContentHash(1_925_082_529)
internal val Res.string.discover_groups_row_join_requests: StringResource by lazy {
      StringResource("string:discover_groups_row_join_requests", "discover_groups_row_join_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24455, 93),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17190, 61),
      ))
    }

@delegate:ResourceContentHash(-78_300_552)
internal val Res.string.discover_groups_row_qr: StringResource by lazy {
      StringResource("string:discover_groups_row_qr", "discover_groups_row_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24549, 62),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17252, 50),
      ))
    }

@delegate:ResourceContentHash(-540_221_876)
internal val Res.string.discover_groups_row_settings: StringResource by lazy {
      StringResource("string:discover_groups_row_settings", "discover_groups_row_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24612, 80),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17303, 56),
      ))
    }

@delegate:ResourceContentHash(-1_109_230_399)
internal val Res.string.discover_groups_save: StringResource by lazy {
      StringResource("string:discover_groups_save", "discover_groups_save", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25392, 52),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17775, 36),
      ))
    }

@delegate:ResourceContentHash(2_121_385_313)
internal val Res.string.discover_groups_save_failed: StringResource by lazy {
      StringResource("string:discover_groups_save_failed", "discover_groups_save_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24693, 115),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17360, 71),
      ))
    }

@delegate:ResourceContentHash(-1_436_310_737)
internal val Res.string.discover_groups_save_post: StringResource by lazy {
      StringResource("string:discover_groups_save_post", "discover_groups_save_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24809, 77),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17432, 45),
      ))
    }

@delegate:ResourceContentHash(1_897_078_249)
internal val Res.string.discover_groups_saved_empty_body: StringResource by lazy {
      StringResource("string:discover_groups_saved_empty_body", "discover_groups_saved_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 24887, 176),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17478, 104),
      ))
    }

@delegate:ResourceContentHash(551_917_705)
internal val Res.string.discover_groups_saved_empty_title: StringResource by lazy {
      StringResource("string:discover_groups_saved_empty_title", "discover_groups_saved_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25064, 101),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17583, 61),
      ))
    }

@delegate:ResourceContentHash(-1_970_996_239)
internal val Res.string.discover_groups_saved_load_failed: StringResource by lazy {
      StringResource("string:discover_groups_saved_load_failed", "discover_groups_saved_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25166, 141),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17645, 77),
      ))
    }

@delegate:ResourceContentHash(91_660_777)
internal val Res.string.discover_groups_saved_posts: StringResource by lazy {
      StringResource("string:discover_groups_saved_posts", "discover_groups_saved_posts", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25308, 83),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17723, 51),
      ))
    }

@delegate:ResourceContentHash(-1_806_405_920)
internal val Res.string.discover_groups_search_members: StringResource by lazy {
      StringResource("string:discover_groups_search_members", "discover_groups_search_members", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25445, 82),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17812, 58),
      ))
    }

@delegate:ResourceContentHash(-1_683_038_074)
internal val Res.string.discover_groups_section_managing: StringResource by lazy {
      StringResource("string:discover_groups_section_managing", "discover_groups_section_managing", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25528, 88),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17871, 68),
      ))
    }

@delegate:ResourceContentHash(1_445_360_509)
internal val Res.string.discover_groups_share_choose_chat: StringResource by lazy {
      StringResource("string:discover_groups_share_choose_chat", "discover_groups_share_choose_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25617, 85),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 17940, 61),
      ))
    }

@delegate:ResourceContentHash(929_739_293)
internal val Res.string.discover_groups_share_failed: StringResource by lazy {
      StringResource("string:discover_groups_share_failed", "discover_groups_share_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25703, 112),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18002, 72),
      ))
    }

@delegate:ResourceContentHash(1_479_874_799)
internal val Res.string.discover_groups_share_loading: StringResource by lazy {
      StringResource("string:discover_groups_share_loading", "discover_groups_share_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25816, 77),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18075, 61),
      ))
    }

@delegate:ResourceContentHash(-323_727_524)
internal val Res.string.discover_groups_share_no_chats: StringResource by lazy {
      StringResource("string:discover_groups_share_no_chats", "discover_groups_share_no_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 25894, 202),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18137, 106),
      ))
    }

@delegate:ResourceContentHash(1_227_976_962)
internal val Res.string.discover_groups_share_post: StringResource by lazy {
      StringResource("string:discover_groups_share_post", "discover_groups_share_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 26097, 62),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18244, 42),
      ))
    }

@delegate:ResourceContentHash(1_707_334_185)
internal val Res.string.discover_groups_share_sent: StringResource by lazy {
      StringResource("string:discover_groups_share_sent", "discover_groups_share_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 26160, 82),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18287, 50),
      ))
    }

@delegate:ResourceContentHash(-374_142_807)
internal val Res.string.discover_groups_stale_comment: StringResource by lazy {
      StringResource("string:discover_groups_stale_comment", "discover_groups_stale_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 26243, 297),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18338, 169),
      ))
    }

@delegate:ResourceContentHash(-1_107_547_902)
internal val Res.string.discover_groups_stale_post: StringResource by lazy {
      StringResource("string:discover_groups_stale_post", "discover_groups_stale_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 26541, 294),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18508, 174),
      ))
    }

@delegate:ResourceContentHash(-1_173_307_583)
internal val Res.string.discover_groups_stale_reload: StringResource by lazy {
      StringResource("string:discover_groups_stale_reload", "discover_groups_stale_reload", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 26836, 248),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18683, 136),
      ))
    }

@delegate:ResourceContentHash(609_754_687)
internal val Res.string.discover_groups_thread_empty_body: StringResource by lazy {
      StringResource("string:discover_groups_thread_empty_body", "discover_groups_thread_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27085, 113),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18820, 73),
      ))
    }

@delegate:ResourceContentHash(-1_396_524_016)
internal val Res.string.discover_groups_thread_empty_title: StringResource by lazy {
      StringResource("string:discover_groups_thread_empty_title", "discover_groups_thread_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27199, 98),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18894, 66),
      ))
    }

@delegate:ResourceContentHash(-700_027_232)
internal val Res.string.discover_groups_timestamp: StringResource by lazy {
      StringResource("string:discover_groups_timestamp", "discover_groups_timestamp", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27298, 45),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 18961, 45),
      ))
    }

@delegate:ResourceContentHash(1_796_747_229)
internal val Res.string.discover_groups_try_again: StringResource by lazy {
      StringResource("string:discover_groups_try_again", "discover_groups_try_again", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27344, 57),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19007, 45),
      ))
    }

@delegate:ResourceContentHash(577_243_474)
internal val Res.string.discover_groups_type_idea: StringResource by lazy {
      StringResource("string:discover_groups_type_idea", "discover_groups_type_idea", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27454, 45),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19101, 41),
      ))
    }

@delegate:ResourceContentHash(577_578_367)
internal val Res.string.discover_groups_type_idea_label: StringResource by lazy {
      StringResource("string:discover_groups_type_idea_label", "discover_groups_type_idea_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27402, 51),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19053, 47),
      ))
    }

@delegate:ResourceContentHash(635_448_295)
internal val Res.string.discover_groups_type_outcome: StringResource by lazy {
      StringResource("string:discover_groups_type_outcome", "discover_groups_type_outcome", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27567, 64),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19198, 48),
      ))
    }

@delegate:ResourceContentHash(-1_140_501_789)
internal val Res.string.discover_groups_type_outcome_label: StringResource by lazy {
      StringResource("string:discover_groups_type_outcome_label", "discover_groups_type_outcome_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27500, 66),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19143, 54),
      ))
    }

@delegate:ResourceContentHash(1_152_045_953)
internal val Res.string.discover_groups_type_plan: StringResource by lazy {
      StringResource("string:discover_groups_type_plan", "discover_groups_type_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27684, 49),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19295, 41),
      ))
    }

@delegate:ResourceContentHash(435_405_194)
internal val Res.string.discover_groups_type_plan_label: StringResource by lazy {
      StringResource("string:discover_groups_type_plan_label", "discover_groups_type_plan_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27632, 51),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19247, 47),
      ))
    }

@delegate:ResourceContentHash(1_531_243_473)
internal val Res.string.discover_groups_type_question: StringResource by lazy {
      StringResource("string:discover_groups_type_question", "discover_groups_type_question", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27794, 57),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19393, 49),
      ))
    }

@delegate:ResourceContentHash(-518_243_544)
internal val Res.string.discover_groups_type_question_label: StringResource by lazy {
      StringResource("string:discover_groups_type_question_label", "discover_groups_type_question_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27734, 59),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19337, 55),
      ))
    }

@delegate:ResourceContentHash(1_248_666_841)
internal val Res.string.discover_groups_unban: StringResource by lazy {
      StringResource("string:discover_groups_unban", "discover_groups_unban", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 28431, 69),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19750, 37),
      ))
    }

@delegate:ResourceContentHash(-1_461_533_494)
internal val Res.string.discover_groups_unban_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_unban_confirm_body", "discover_groups_unban_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 27852, 454),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19443, 246),
      ))
    }

@delegate:ResourceContentHash(1_855_904_040)
internal val Res.string.discover_groups_unban_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_unban_confirm_title", "discover_groups_unban_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 28307, 123),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19690, 59),
      ))
    }

@delegate:ResourceContentHash(1_196_449_222)
internal val Res.string.discover_groups_unlike_failed: StringResource by lazy {
      StringResource("string:discover_groups_unlike_failed", "discover_groups_unlike_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 28501, 93),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19788, 73),
      ))
    }

@delegate:ResourceContentHash(1_224_357_715)
internal val Res.string.discover_groups_username_note: StringResource by lazy {
      StringResource("string:discover_groups_username_note", "discover_groups_username_note", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 28595, 201),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 19862, 145),
      ))
    }

@delegate:ResourceContentHash(-217_018_899)
internal val Res.string.discover_groups_verify_email_to_chat: StringResource by lazy {
      StringResource("string:discover_groups_verify_email_to_chat", "discover_groups_verify_email_to_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 28797, 164),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20008, 116),
      ))
    }

@delegate:ResourceContentHash(1_911_937_625)
internal val Res.string.discover_groups_verify_email_to_comment: StringResource by lazy {
      StringResource("string:discover_groups_verify_email_to_comment", "discover_groups_verify_email_to_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 28962, 195),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20125, 115),
      ))
    }

@delegate:ResourceContentHash(324_185_299)
internal val Res.string.discover_groups_verify_email_to_post: StringResource by lazy {
      StringResource("string:discover_groups_verify_email_to_post", "discover_groups_verify_email_to_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 29158, 184),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20241, 116),
      ))
    }

@delegate:ResourceContentHash(-149_122_872)
internal val Res.string.discover_groups_view_profile: StringResource by lazy {
      StringResource("string:discover_groups_view_profile", "discover_groups_view_profile", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 29343, 76),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20358, 52),
      ))
    }

@delegate:ResourceContentHash(223_238_176)
internal val Res.string.discover_groups_visibility_note: StringResource by lazy {
      StringResource("string:discover_groups_visibility_note", "discover_groups_visibility_note", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 29420, 283),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20411, 199),
      ))
    }

@delegate:ResourceContentHash(-1_873_546_570)
internal val Res.string.discover_groups_visibility_private: StringResource by lazy {
      StringResource("string:discover_groups_visibility_private", "discover_groups_visibility_private", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 29936, 66),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20763, 54),
      ))
    }

@delegate:ResourceContentHash(-1_037_984_212)
internal val Res.string.discover_groups_visibility_private_body: StringResource by lazy {
      StringResource("string:discover_groups_visibility_private_body", "discover_groups_visibility_private_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 29704, 231),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20611, 151),
      ))
    }

@delegate:ResourceContentHash(-49_876_682)
internal val Res.string.discover_groups_visibility_public: StringResource by lazy {
      StringResource("string:discover_groups_visibility_public", "discover_groups_visibility_public", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30270, 65),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20961, 49),
      ))
    }

@delegate:ResourceContentHash(-892_689_095)
internal val Res.string.discover_groups_visibility_public_body: StringResource by lazy {
      StringResource("string:discover_groups_visibility_public_body", "discover_groups_visibility_public_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30003, 266),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 20818, 142),
      ))
    }

@delegate:ResourceContentHash(-1_884_510_178)
internal val Res.string.discover_groups_who_can_join: StringResource by lazy {
      StringResource("string:discover_groups_who_can_join", "discover_groups_who_can_join", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30336, 84),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21011, 52),
      ))
    }

@delegate:ResourceContentHash(-120_167_049)
internal val Res.string.discover_groups_write_post: StringResource by lazy {
      StringResource("string:discover_groups_write_post", "discover_groups_write_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30421, 74),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21064, 50),
      ))
    }

@delegate:ResourceContentHash(-1_359_124_167)
internal val Res.string.feed_age_now: StringResource by lazy {
      StringResource("string:feed_age_now", "feed_age_now", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_feed.commonMain.cvr", 272, 48),
        ResourceItem(setOf(), "${MD}values/strings_feed.commonMain.cvr", 314, 24),
      ))
    }

@delegate:ResourceContentHash(193_783_008)
internal val Res.string.feed_title: StringResource by lazy {
      StringResource("string:feed_title", "feed_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_feed.commonMain.cvr", 321, 30),
        ResourceItem(setOf(), "${MD}values/strings_feed.commonMain.cvr", 339, 30),
      ))
    }

@delegate:ResourceContentHash(964_715_723)
internal val Res.string.field_error_code_incomplete: StringResource by lazy {
      StringResource("string:field_error_code_incomplete", "field_error_code_incomplete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3245, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2459, 67),
      ))
    }

@delegate:ResourceContentHash(1_977_828_744)
internal val Res.string.field_error_code_rejected: StringResource by lazy {
      StringResource("string:field_error_code_rejected", "field_error_code_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3321, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2527, 109),
      ))
    }

@delegate:ResourceContentHash(2_119_733_258)
internal val Res.string.field_error_display_name_too_long: StringResource by lazy {
      StringResource("string:field_error_display_name_too_long", "field_error_display_name_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3471, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2637, 69),
      ))
    }

@delegate:ResourceContentHash(-1_602_243_222)
internal val Res.string.field_error_email_invalid: StringResource by lazy {
      StringResource("string:field_error_email_invalid", "field_error_email_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3561, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2707, 69),
      ))
    }

@delegate:ResourceContentHash(653_371_536)
internal val Res.string.field_error_password_needs_letter_and_digit: StringResource by lazy {
      StringResource("string:field_error_password_needs_letter_and_digit", "field_error_password_needs_letter_and_digit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3671, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2777, 107),
      ))
    }

@delegate:ResourceContentHash(33_353_415)
internal val Res.string.field_error_password_rejected: StringResource by lazy {
      StringResource("string:field_error_password_rejected", "field_error_password_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3815, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2885, 125),
      ))
    }

@delegate:ResourceContentHash(665_628_463)
internal val Res.string.field_error_password_too_long: StringResource by lazy {
      StringResource("string:field_error_password_too_long", "field_error_password_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 3977, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3011, 69),
      ))
    }

@delegate:ResourceContentHash(1_600_240_502)
internal val Res.string.field_error_password_too_short: StringResource by lazy {
      StringResource("string:field_error_password_too_short", "field_error_password_too_short", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4063, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3081, 70),
      ))
    }

@delegate:ResourceContentHash(-855_347_391)
internal val Res.string.field_error_passwords_do_not_match: StringResource by lazy {
      StringResource("string:field_error_passwords_do_not_match", "field_error_passwords_do_not_match", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4150, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3152, 78),
      ))
    }

@delegate:ResourceContentHash(-425_547_143)
internal val Res.string.field_error_required: StringResource by lazy {
      StringResource("string:field_error_required", "field_error_required", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4253, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3231, 40),
      ))
    }

@delegate:ResourceContentHash(175_616_931)
internal val Res.string.field_error_username_bad_characters: StringResource by lazy {
      StringResource("string:field_error_username_bad_characters", "field_error_username_bad_characters", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4326, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3272, 87),
      ))
    }

@delegate:ResourceContentHash(1_438_416_908)
internal val Res.string.field_error_username_reserved: StringResource by lazy {
      StringResource("string:field_error_username_reserved", "field_error_username_reserved", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4438, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3360, 77),
      ))
    }

@delegate:ResourceContentHash(-487_768_073)
internal val Res.string.field_error_username_too_long: StringResource by lazy {
      StringResource("string:field_error_username_too_long", "field_error_username_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4556, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3438, 65),
      ))
    }

@delegate:ResourceContentHash(1_247_179_265)
internal val Res.string.field_error_username_too_short: StringResource by lazy {
      StringResource("string:field_error_username_too_short", "field_error_username_too_short", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4642, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3504, 66),
      ))
    }

@delegate:ResourceContentHash(1_088_208_580)
internal val Res.string.freshness_just_now: StringResource by lazy {
      StringResource("string:freshness_just_now", "freshness_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4729, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3571, 50),
      ))
    }

@delegate:ResourceContentHash(1_099_876_995)
internal val Res.string.freshness_over_a_day: StringResource by lazy {
      StringResource("string:freshness_over_a_day", "freshness_over_a_day", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4808, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3622, 64),
      ))
    }

@delegate:ResourceContentHash(2_996_539)
internal val Res.string.group_exit_owner_alone: StringResource by lazy {
      StringResource("string:group_exit_owner_alone", "group_exit_owner_alone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4905, 234),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3687, 170),
      ))
    }

@delegate:ResourceContentHash(271_170_871)
internal val Res.string.group_exit_owner_must_hand_over: StringResource by lazy {
      StringResource("string:group_exit_owner_must_hand_over", "group_exit_owner_must_hand_over", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 5140, 547),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3858, 295),
      ))
    }

@delegate:ResourceContentHash(-1_881_944_040)
internal val Res.string.group_feed_empty_admins_only: StringResource by lazy {
      StringResource("string:group_feed_empty_admins_only", "group_feed_empty_admins_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 5688, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4154, 88),
      ))
    }

@delegate:ResourceContentHash(1_259_315_357)
internal val Res.string.group_feed_empty_unknown: StringResource by lazy {
      StringResource("string:group_feed_empty_unknown", "group_feed_empty_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 5837, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4243, 76),
      ))
    }

@delegate:ResourceContentHash(-1_975_204_126)
internal val Res.string.group_member_joined_on: StringResource by lazy {
      StringResource("string:group_member_joined_on", "group_member_joined_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 5954, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4320, 50),
      ))
    }

@delegate:ResourceContentHash(1_347_658_300)
internal val Res.string.group_member_you: StringResource by lazy {
      StringResource("string:group_member_you", "group_member_you", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6017, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4371, 28),
      ))
    }

@delegate:ResourceContentHash(62_796_179)
internal val Res.string.group_role_admin: StringResource by lazy {
      StringResource("string:group_role_admin", "group_role_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6082, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4400, 32),
      ))
    }

@delegate:ResourceContentHash(155_582_649)
internal val Res.string.group_role_owner: StringResource by lazy {
      StringResource("string:group_role_owner", "group_role_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6123, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4433, 32),
      ))
    }

@delegate:ResourceContentHash(-1_783_497_584)
internal val Res.string.group_settings_admins_only: StringResource by lazy {
      StringResource("string:group_settings_admins_only", "group_settings_admins_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30496, 194),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21115, 102),
      ))
    }

@delegate:ResourceContentHash(-968_720_965)
internal val Res.string.group_settings_chat: StringResource by lazy {
      StringResource("string:group_settings_chat", "group_settings_chat", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30691, 67),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21218, 47),
      ))
    }

@delegate:ResourceContentHash(-1_430_115_542)
internal val Res.string.group_settings_description: StringResource by lazy {
      StringResource("string:group_settings_description", "group_settings_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30759, 58),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21266, 50),
      ))
    }

@delegate:ResourceContentHash(1_644_618_639)
internal val Res.string.group_settings_discover: StringResource by lazy {
      StringResource("string:group_settings_discover", "group_settings_discover", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30818, 59),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21317, 51),
      ))
    }

@delegate:ResourceContentHash(1_151_776_430)
internal val Res.string.group_settings_everyone: StringResource by lazy {
      StringResource("string:group_settings_everyone", "group_settings_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 30878, 139),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21369, 83),
      ))
    }

@delegate:ResourceContentHash(305_223_744)
internal val Res.string.group_settings_identity: StringResource by lazy {
      StringResource("string:group_settings_identity", "group_settings_identity", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31018, 51),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21453, 43),
      ))
    }

@delegate:ResourceContentHash(-1_454_974_777)
internal val Res.string.group_settings_name: StringResource by lazy {
      StringResource("string:group_settings_name", "group_settings_name", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31070, 67),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21497, 43),
      ))
    }

@delegate:ResourceContentHash(920_531_331)
internal val Res.string.group_settings_posting: StringResource by lazy {
      StringResource("string:group_settings_posting", "group_settings_posting", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31138, 86),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21541, 46),
      ))
    }

@delegate:ResourceContentHash(459_813_884)
internal val Res.string.group_settings_save: StringResource by lazy {
      StringResource("string:group_settings_save", "group_settings_save", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31225, 51),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21588, 43),
      ))
    }

@delegate:ResourceContentHash(-540_221_876)
internal val Res.string.group_settings_title: StringResource by lazy {
      StringResource("string:group_settings_title", "group_settings_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31277, 72),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21632, 48),
      ))
    }

@delegate:ResourceContentHash(-2_087_543_891)
internal val Res.string.group_settings_unavailable: StringResource by lazy {
      StringResource("string:group_settings_unavailable", "group_settings_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31350, 106),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21681, 78),
      ))
    }

@delegate:ResourceContentHash(1_530_552_508)
internal val Res.string.group_settings_username: StringResource by lazy {
      StringResource("string:group_settings_username", "group_settings_username", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 31457, 67),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 21760, 51),
      ))
    }

@delegate:ResourceContentHash(552_856_260)
internal val Res.string.group_visibility_private: StringResource by lazy {
      StringResource("string:group_visibility_private", "group_visibility_private", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6172, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4466, 52),
      ))
    }

@delegate:ResourceContentHash(1_528_797_534)
internal val Res.string.group_visibility_public: StringResource by lazy {
      StringResource("string:group_visibility_public", "group_visibility_public", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6245, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4519, 47),
      ))
    }

@delegate:ResourceContentHash(-1_919_758_117)
internal val Res.string.groups_list_create_description: StringResource by lazy {
      StringResource("string:groups_list_create_description", "groups_list_create_description", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 10, 78),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 10, 58),
      ))
    }

@delegate:ResourceContentHash(1_809_357_230)
internal val Res.string.groups_list_empty_body: StringResource by lazy {
      StringResource("string:groups_list_empty_body", "groups_list_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 89, 98),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 69, 66),
      ))
    }

@delegate:ResourceContentHash(860_280_478)
internal val Res.string.groups_list_empty_title: StringResource by lazy {
      StringResource("string:groups_list_empty_title", "groups_list_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 188, 67),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 136, 51),
      ))
    }

@delegate:ResourceContentHash(-1_306_818_804)
internal val Res.string.groups_list_error_load: StringResource by lazy {
      StringResource("string:groups_list_error_load", "groups_list_error_load", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 388, 102),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 260, 66),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("discover_groups_replying_to", Res.string.discover_groups_replying_to)
  map.put("discover_groups_report", Res.string.discover_groups_report)
  map.put("discover_groups_report_group", Res.string.discover_groups_report_group)
  map.put("discover_groups_report_post", Res.string.discover_groups_report_post)
  map.put("discover_groups_row_banned", Res.string.discover_groups_row_banned)
  map.put("discover_groups_row_chat", Res.string.discover_groups_row_chat)
  map.put("discover_groups_row_invite_link", Res.string.discover_groups_row_invite_link)
  map.put("discover_groups_row_join_requests", Res.string.discover_groups_row_join_requests)
  map.put("discover_groups_row_qr", Res.string.discover_groups_row_qr)
  map.put("discover_groups_row_settings", Res.string.discover_groups_row_settings)
  map.put("discover_groups_save", Res.string.discover_groups_save)
  map.put("discover_groups_save_failed", Res.string.discover_groups_save_failed)
  map.put("discover_groups_save_post", Res.string.discover_groups_save_post)
  map.put("discover_groups_saved_empty_body", Res.string.discover_groups_saved_empty_body)
  map.put("discover_groups_saved_empty_title", Res.string.discover_groups_saved_empty_title)
  map.put("discover_groups_saved_load_failed", Res.string.discover_groups_saved_load_failed)
  map.put("discover_groups_saved_posts", Res.string.discover_groups_saved_posts)
  map.put("discover_groups_search_members", Res.string.discover_groups_search_members)
  map.put("discover_groups_section_managing", Res.string.discover_groups_section_managing)
  map.put("discover_groups_share_choose_chat", Res.string.discover_groups_share_choose_chat)
  map.put("discover_groups_share_failed", Res.string.discover_groups_share_failed)
  map.put("discover_groups_share_loading", Res.string.discover_groups_share_loading)
  map.put("discover_groups_share_no_chats", Res.string.discover_groups_share_no_chats)
  map.put("discover_groups_share_post", Res.string.discover_groups_share_post)
  map.put("discover_groups_share_sent", Res.string.discover_groups_share_sent)
  map.put("discover_groups_stale_comment", Res.string.discover_groups_stale_comment)
  map.put("discover_groups_stale_post", Res.string.discover_groups_stale_post)
  map.put("discover_groups_stale_reload", Res.string.discover_groups_stale_reload)
  map.put("discover_groups_thread_empty_body", Res.string.discover_groups_thread_empty_body)
  map.put("discover_groups_thread_empty_title", Res.string.discover_groups_thread_empty_title)
  map.put("discover_groups_timestamp", Res.string.discover_groups_timestamp)
  map.put("discover_groups_try_again", Res.string.discover_groups_try_again)
  map.put("discover_groups_type_idea", Res.string.discover_groups_type_idea)
  map.put("discover_groups_type_idea_label", Res.string.discover_groups_type_idea_label)
  map.put("discover_groups_type_outcome", Res.string.discover_groups_type_outcome)
  map.put("discover_groups_type_outcome_label", Res.string.discover_groups_type_outcome_label)
  map.put("discover_groups_type_plan", Res.string.discover_groups_type_plan)
  map.put("discover_groups_type_plan_label", Res.string.discover_groups_type_plan_label)
  map.put("discover_groups_type_question", Res.string.discover_groups_type_question)
  map.put("discover_groups_type_question_label", Res.string.discover_groups_type_question_label)
  map.put("discover_groups_unban", Res.string.discover_groups_unban)
  map.put("discover_groups_unban_confirm_body", Res.string.discover_groups_unban_confirm_body)
  map.put("discover_groups_unban_confirm_title", Res.string.discover_groups_unban_confirm_title)
  map.put("discover_groups_unlike_failed", Res.string.discover_groups_unlike_failed)
  map.put("discover_groups_username_note", Res.string.discover_groups_username_note)
  map.put("discover_groups_verify_email_to_chat", Res.string.discover_groups_verify_email_to_chat)
  map.put("discover_groups_verify_email_to_comment", Res.string.discover_groups_verify_email_to_comment)
  map.put("discover_groups_verify_email_to_post", Res.string.discover_groups_verify_email_to_post)
  map.put("discover_groups_view_profile", Res.string.discover_groups_view_profile)
  map.put("discover_groups_visibility_note", Res.string.discover_groups_visibility_note)
  map.put("discover_groups_visibility_private", Res.string.discover_groups_visibility_private)
  map.put("discover_groups_visibility_private_body", Res.string.discover_groups_visibility_private_body)
  map.put("discover_groups_visibility_public", Res.string.discover_groups_visibility_public)
  map.put("discover_groups_visibility_public_body", Res.string.discover_groups_visibility_public_body)
  map.put("discover_groups_who_can_join", Res.string.discover_groups_who_can_join)
  map.put("discover_groups_write_post", Res.string.discover_groups_write_post)
  map.put("feed_age_now", Res.string.feed_age_now)
  map.put("feed_title", Res.string.feed_title)
  map.put("field_error_code_incomplete", Res.string.field_error_code_incomplete)
  map.put("field_error_code_rejected", Res.string.field_error_code_rejected)
  map.put("field_error_display_name_too_long", Res.string.field_error_display_name_too_long)
  map.put("field_error_email_invalid", Res.string.field_error_email_invalid)
  map.put("field_error_password_needs_letter_and_digit", Res.string.field_error_password_needs_letter_and_digit)
  map.put("field_error_password_rejected", Res.string.field_error_password_rejected)
  map.put("field_error_password_too_long", Res.string.field_error_password_too_long)
  map.put("field_error_password_too_short", Res.string.field_error_password_too_short)
  map.put("field_error_passwords_do_not_match", Res.string.field_error_passwords_do_not_match)
  map.put("field_error_required", Res.string.field_error_required)
  map.put("field_error_username_bad_characters", Res.string.field_error_username_bad_characters)
  map.put("field_error_username_reserved", Res.string.field_error_username_reserved)
  map.put("field_error_username_too_long", Res.string.field_error_username_too_long)
  map.put("field_error_username_too_short", Res.string.field_error_username_too_short)
  map.put("freshness_just_now", Res.string.freshness_just_now)
  map.put("freshness_over_a_day", Res.string.freshness_over_a_day)
  map.put("group_exit_owner_alone", Res.string.group_exit_owner_alone)
  map.put("group_exit_owner_must_hand_over", Res.string.group_exit_owner_must_hand_over)
  map.put("group_feed_empty_admins_only", Res.string.group_feed_empty_admins_only)
  map.put("group_feed_empty_unknown", Res.string.group_feed_empty_unknown)
  map.put("group_member_joined_on", Res.string.group_member_joined_on)
  map.put("group_member_you", Res.string.group_member_you)
  map.put("group_role_admin", Res.string.group_role_admin)
  map.put("group_role_owner", Res.string.group_role_owner)
  map.put("group_settings_admins_only", Res.string.group_settings_admins_only)
  map.put("group_settings_chat", Res.string.group_settings_chat)
  map.put("group_settings_description", Res.string.group_settings_description)
  map.put("group_settings_discover", Res.string.group_settings_discover)
  map.put("group_settings_everyone", Res.string.group_settings_everyone)
  map.put("group_settings_identity", Res.string.group_settings_identity)
  map.put("group_settings_name", Res.string.group_settings_name)
  map.put("group_settings_posting", Res.string.group_settings_posting)
  map.put("group_settings_save", Res.string.group_settings_save)
  map.put("group_settings_title", Res.string.group_settings_title)
  map.put("group_settings_unavailable", Res.string.group_settings_unavailable)
  map.put("group_settings_username", Res.string.group_settings_username)
  map.put("group_visibility_private", Res.string.group_visibility_private)
  map.put("group_visibility_public", Res.string.group_visibility_public)
  map.put("groups_list_create_description", Res.string.groups_list_create_description)
  map.put("groups_list_empty_body", Res.string.groups_list_empty_body)
  map.put("groups_list_empty_title", Res.string.groups_list_empty_title)
  map.put("groups_list_error_load", Res.string.groups_list_error_load)
}
